import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

interface Args {
	value: boolean;
	isDisabled: boolean;
	showReadMore: boolean;
	onChange: (value: boolean) => void;
	theme?: string;
}

enum Invert {
	TRUE = 'true',
	FALSE = 'false',
}

export default class MetricEditInvertComponent extends Component<Args> {
	shownOptions = [
		{ value: Invert.FALSE, label: 'Trending UP is positive' },
		{ value: Invert.TRUE, label: 'Trending DOWN is positive' },
	];

	// generate a unique name, otherwise more component instances on page can screw things up
	name = `invert-${Math.floor(Math.random() * 1000)}`;

	get selectedOption(): Invert.TRUE | Invert.FALSE {
		return Invert[this.args.value ? 'TRUE' : 'FALSE'];
	}

	get tooltipText(): string {
		let text =
			'Some metrics are better (positive) when the value is lower, like Bounce rate, Churn rate, Cancellations, ... This will also affect how the comparison value and goal comparisons are calculated.';
		if (this.args.showReadMore) {
			text +=
				' <a href="https://help.databox.com/how-to-change-the-percentage-change-color-for-a-metric" target="_blank">Read more</a>';
		}
		return text;
	}

	@action
	changeValue(value: AnySimpleValue): void {
		this.args.onChange(value === Invert.TRUE);
	}
	<template>
		<div class="row metric-invert">

			<div class="subtitle">
				Favorable trend
				<ToolTipWithIconComponent
					@text={{this.tooltipText}}
					@theme={{@theme}}
					@maxWidth={{230}}
				/>
			</div>

			<FormRadiobuttonGroupComponent
				class="radiobutton-default"
				@name={{this.name}}
				@selected={{this.selectedOption}}
				@options={{this.shownOptions}}
				@theme={{@theme}}
				@onChange={{this.changeValue}}
				@isDisabled={{@isDisabled}}
			/>

		</div>
	</template>
}
